import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardProductComponent } from './card-product.component';
import { LinkProductModule } from '../link-product/link-product.module';
import { BookmarkModule } from '../bookmark/bookmark.module';
import { AttributesModule } from '../attributes/attributes.module';
import { ImagePreloadDirectiveModule } from '../../directives/image-preload/image-preload.directive';

@NgModule({
  imports: [
    CommonModule,
    LinkProductModule,
    BookmarkModule,
    AttributesModule,
    ImagePreloadDirectiveModule
  ],
  declarations: [ CardProductComponent ],
  exports: [ CardProductComponent ],
})
export class CardProductModule { }
